import { Component, OnInit, ViewChild } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MAT_DIALOG_DATA,
  MatSort
} from '@angular/material';

import {  MatDialog, MatDialogRef, } from '@angular/material/dialog';

import { EdittransporterComponent } from "../edittransporter/edittransporter.component";
import { TransporterService } from '../../../services/transporter/transporter.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';

@Component({
  selector: 'app-alltransporter',
  templateUrl: './alltransporter.component.html',
  styleUrls: ['./alltransporter.component.scss']
})
export class AlltransporterComponent implements OnInit {
  showFiller = false;

  columnsToDisplay = [
    'transporterName',
    'transporterAddress1',
    'transporterPhoneNumber',
    'contactPersonName',
    'actions'
  ];
  
  //transporterDataArray = new MatTableDataSource<transporterListElement>(ELEMENT_DATA);

  transporterDataArray = new MatTableDataSource;
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
isLoading: boolean = false
  constructor(
    public dialog: MatDialog,
    public transporterService: TransporterService
  ) {
    
  }

  ngOnInit() {
    this.getAllTransporters();   
    this.transporterDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'transporterName': return item.transporterName;
      }
    };
    this.transporterDataArray.sort = this.sort;
  }

  getAllTransporters() {
  this.isLoading = true;
  this.transporterDataArray.data = [];
    this.transporterService.getAllTransporters().subscribe(res => {
      console.log(res);
      this.isLoading = false;
      this.transporterDataArray.data = res;
      this.transporterDataArray.paginator = this.paginator;
     }, Error => {
       this.isLoading = false;
       console.log(Error);
     });
  }
 
  edittransporter(id) {

    console.log(id);
    let editDialog = this.dialog.open(EdittransporterComponent, {
      width:'800px',
      data:{
        transporter:id
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
    editDialog.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  applyFilter(filterValue: string) {
    this.transporterDataArray.filter = filterValue.trim().toLowerCase();
  }
}
export interface transporterListElement {
  transporterName: string,
  transporterAddress1: string,
  transporterAddress2: string,
  transporterAddress3: string,
  transporterPhoneNumber: string,
  contactPersonName: string,
  contactPersonPhoneNumber: string,
  secondarycontactPersonPhoneNumber: string,
  actions: any;
}


export class TransporterDataSource extends DataSource<any>{
  constructor(private transporterService: TransporterService) {
    super();
  }

  connect(): Observable<transporterListElement[]> {
    return this.transporterService.getAllTransporters();
  }

  disconnect() {}
}

